//import axios from 'src/utils/axios';

import accountService from 'src/services/accountService';
import claimService from 'src/services/claimService';
import { SET_DEALER_INFO, SET_ORDER_INFO } from './claimActions';

export const LOGIN_REQUEST = '@account/login-request';
export const LOGIN_SUCCESS = '@account/login-success';
export const LOGIN_FAILURE = '@account/login-failure';
export const SILENT_LOGIN = '@account/silent-login';
export const EXTERNAL_LOGIN = '@account/external-login';
export const LOGOUT = '@account/logout';
export const REGISTER = '@account/register';
export const REGISTER_FAILURE = '@account/register-failure';
export const REGISTRATION_COMPLETE = '@account/register-complete';
export const REGISTRATION_COMPLETE_FAILURE =
  '@account/register-complete-failure';
export const UPDATE_PROFILE = '@account/update-profile';
export const UPDATE_DEALER = '@account/update-dealer';
export const UPDATE_PROFILE_FAILURE = '@account/update-profile-error';
export const ACCOUNT_LOCATE_FAILURE = '@account/locate-account-failure';
export const ACCOUNT_LOCATED = '@account/locate-account';
export const ACCOUNT_NOTIFICATION_SENT = '@account/account-notification-sent';
export const ACCOUNT_LOCATED_BY_ID = '@account/account-locate-by-id';

export const CLEAR_COMPANY_CREATE_FLAG = '@account/clear-create-company-flag';
export const CREATE_COMPANY = '@account/create-company';
export const CREATE_USER = '@account/create-company-user';
export const CREATE_USER_ROLE = '@account/create-company-user-role';
export const CREATE_USER_TOKEN = '@account/create-user-token';
export const VERIFICATION_RESULTS = '@account/verification-results';
export const CLAIMS_QORE_ACCOUNT = '@account/claim-qore-user';
export const UPDATE_USER = '@account/update-user';
export function setUserData(user) {
  return dispatch =>
    dispatch({
      type: SILENT_LOGIN,
      payload: {
        user
      }
    });
}

export function updateUserData(dealerUser) {
  return dispatch =>
    dispatch({
      type: UPDATE_USER,
      payload: {
        dealerUser
      }
    });
}

export function logout() {
  return async dispatch => {
    //authService.logout();

    dispatch({
      type: LOGOUT
    });
  };
}

export function externalLogin(dealerCode, trackingNumber) {
  return async (dispatch) => {
    try {
      dispatch({ type: LOGIN_REQUEST });

      const { dealerInfo, orderInfo } = await claimService.lookupPurchaseOrderandDealerCode(dealerCode, trackingNumber);

      dispatch({
        type: SET_DEALER_INFO,
        payload: dealerInfo
      });
      dispatch({
        type: SET_ORDER_INFO,
        payload: orderInfo

      });
      return {
        dealerInfo: dealerInfo,
        orderInfo: orderInfo,
      };
    } catch (error) {
      dispatch({ type: LOGIN_FAILURE });
      throw error;
    }
  };
}

export function createCompany(companyInfo) {
  return async dispatch => {
    try {
      const responsePayload = await accountService.createCompany(companyInfo);
      dispatch({
        type: CREATE_COMPANY,
        payload: responsePayload
      });
    } catch (error) {
      dispatch({ type: UPDATE_PROFILE_FAILURE });
      throw error;
    }
  };
}

export function createCompanyUserJwtToken(userInfo) {
  return async dispatch => {
    try {
      const responsePayload = await accountService.createCompany(userInfo);
      dispatch({
        type: CREATE_USER_TOKEN,
        payload: responsePayload
      });
    } catch (error) {
      dispatch({ type: UPDATE_PROFILE_FAILURE });
      throw error;
    }
  };
}

export function clearCreateCompanyFlag() {
  return async dispatch => {
    dispatch({
      type: CLEAR_COMPANY_CREATE_FLAG,
      payload: false
    });
  };
}

export function updateProfile(update) {
  return async dispatch => {
    try {
      const responsePayload = await accountService.updateProfile(update);
      dispatch({
        type: UPDATE_PROFILE,
        payload: responsePayload
      });
    } catch (error) {
      dispatch({ type: UPDATE_PROFILE_FAILURE });
      throw error;
    }
  };
}

export function updateDealer(dealer) {
  return async (dispatch) => {
    dispatch({
      type: UPDATE_DEALER,
      payload: { ...dealer }
    });
  };
}

export function resetPassword(update) {
  return async dispatch => {
    try {
      const result = await accountService.resetPassword(update);
      dispatch({
        type: UPDATE_PROFILE,
        payload: result.data
      });
    } catch (error) {
      dispatch({ type: UPDATE_PROFILE_FAILURE });
      throw error;
    }
  };
}
